export const PERFORMANCE_INSIGHTS_TYPE = {
  ISSUE: 'issue',
  RECOMMENDATION: 'recommendation',
};
export const PERFORMANCE_INSIGHTS_ISSUE = {
  BUDGET: 'BudgetConstraint',
  BID: 'LimitedByAutoBidTargetPerf',
};
export const PERFORMANCE_INSIGHTS_ACTION = {
  VIEW_ALL_ISSUES: _TL_('View all issues'),
  SAVE_CHANGES: _TL_('Save changes'),
  VIEW_RECOMMENDATIONS: _TL_('View recommendations'),
  VIEW_RECOMMENDATION: _TL_('View recommendation'),
  APPLY_RECOMMENDATION: _TL_('Apply recommendation'),
  CLOSE: _TL_('Close'),
};
export const PERFORMANCE_INSIGHTS_POPUP_CONFIG = {
  [PERFORMANCE_INSIGHTS_TYPE.ISSUE]: {
    [PERFORMANCE_INSIGHTS_ISSUE.BUDGET]: {
      title: _TL_('Campaign performance is limited by budget'),
      chartTitle: _TL_('Impressions between {{startDate}} and {{endDate}}'),
      description: _TL_('Your campaign is estimated to miss {{missedImpressions}} impressions on {{endDate}} due to this issue.'),
      pitching: _TL_('It is expected that your ads would be shown more with a new campaign budget in next several weeks.'),
      actionDetails: [
        _TL_('Increase your campaign budget from {{actualBudget}} to {{recommendedBudget}}'),
      ],
      action: PERFORMANCE_INSIGHTS_ACTION.VIEW_ALL_ISSUES,
    },
    [PERFORMANCE_INSIGHTS_ISSUE.BID]: {
      title: _TL_('Campaign performance is limited by target CPA'),
      chartTitle: _TL_('Conversions between {{startDate}} and {{endDate}}'),
      description: _TL_('Your campaign is estimated to miss out {{missedConversions}} conversions between {{startDate}} and {{endDate}} due to this issue.'),
      pitching: _TL_('It is expected that your ads will show more with a new CPA target value in next several weeks.'),
      actionDetails: [
        _TL_('Set target CPA from {{latestActualTarget}} to {{latestSuggestTarget}} to remove the constraint'),
        _TL_('Set target CPA from {{latestActualTarget}} to {{verticalTarget}}, as {{verticalPercentage}}% of competing campaigns do'),
      ],
      action: PERFORMANCE_INSIGHTS_ACTION.VIEW_ALL_ISSUES,
    },
  },
};

export const PERFORMANCE_INSIGHTS_PANEL_CONTAINER = '.performance-insights-popover-container';
